import styled, { css } from 'styled-components'
import { SearchMode } from 'src/types/search'

export const PaxesWrapper = styled.div<{ mode: SearchMode }>`
  padding-block: 13px;
  padding-inline: 0;
  margin-block-end: 0;

  & svg {
    flex-shrink: 0;
  }

  & > div > button {
    width: 100%;
  }

  & > div > div > button {
    height: 48px;

    &:hover {
      background: var(--color--neutral--300);

      & * {
        background: transparent;
      }
    }
  }

  ${({ mode, theme }) =>
    mode === SearchMode.Borderless &&
    css`
      overflow: hidden;
      flex: 1 1 auto;
      & [data-radix-popper-content-wrapper] > div {
        border-color: ${theme.colors.grey2};
      }
      & [data-radix-popper-content-wrapper] {
        inset-block-start: 5px !important;
        z-index: var(--z-low) !important;
      }
    `};

  ${({ mode }) =>
    mode === SearchMode.Full &&
    css`
      z-index: var(--z-base);
      & [data-radix-popper-content-wrapper] {
        width: 100%;
        z-index: var(--z-low) !important;
        transform: translate3d(0, 0, 0) !important;
        height: 100%;
        overflow: auto;
        min-width: unset !important;

        & > div {
          height: 100%;
          overflow: auto;
          border-radius: 0;
        }
      }
    `}
`
